import dayjs from "dayjs";
import React, { useEffect, useState } from "react";
import { Modal, Button, SelectPicker } from "rsuite";

function DoctorDetailModal({ open, setOpen }) {
  let title = open[1]?.title;
  let name = open[3]?.name;
  let number = open[4]?.number;
  let Identity = open[2]?.Identity;
  let startTime = dayjs(open[4]?.time[0]).format("MM/DD HH:mm");
  let endTime = dayjs(open[4]?.time[1]).format("MM/DD HH:mm");

  const [identity, setIdentity] = useState("");

  useEffect(() => {
    if (Identity === "tbc_doctor") {
      setIdentity("醫師");
    } else if (Identity === "radiation_therapy") {
      setIdentity("放射師");
    } else if (Identity === "nurse") {
      setIdentity("護理師");
    } else {
      setIdentity("醫師");
    }
  }, [Identity]);

  //console.log(open);

  const numberJoin = number?.filter((item) => item !== null)?.join(",");

  //console.log(numberJoin);

  return (
    <Modal
      open={open[0]?.open}
      backdrop={true}
      onClose={() => {
        setOpen(!open[0]?.open);
      }}
    >
      <Modal.Header closeButton={true}>
        <Modal.Title>
          <div style={{ display: "flex", justifyContent: "center" }}>
            {title}
          </div>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div style={{ padding: "8px" }}>
          值班人員: {name} {identity}
        </div>
        <div style={{ padding: "8px" }}>
          時段: {startTime} 至 {endTime}
        </div>
        <div style={{ padding: "8px" }}>聯絡資訊: {numberJoin}</div>
      </Modal.Body>
      <Modal.Footer></Modal.Footer>
    </Modal>
  );
}

export default DoctorDetailModal;
